gsap.registerPlugin(ScrollTrigger, SplitText); //, TextPlugin, ScrollToPlugin, DrawSVGPlugin

ScrollTrigger.defaults({
  toggleActions: "play none none reverse",
  // markers: true,
  end: "bottom center",
}); 

// When the user scrolls the page, execute position_header
window.onscroll = function() {position_header()};

// Get the header
const header = document.querySelector(".header-fixed");

// Get the offset position of the navbar
const sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function position_header() {
  if (window.pageYOffset > sticky) {
    header.classList.remove("hide");
    header.classList.add("fixed");
  } else {
    header.classList.remove("fixed");
    header.classList.add("hide");
  }
};

let tlnav = gsap.timeline();

tlnav.from('.navbar-mobile .nav-item', {
  delay: 0.0,
  duration: 0.05, 
  autoAlpha: 0,
  y:-100,
  stagger: 0.035
});

tlnav.pause();

document.querySelector("#navbar-toggle").addEventListener('click', () => {
  tlnav.restart();
});

//the_permalink(11) ne marchait pas
// setTimeout(() => {
//   if (document.querySelector(".gfield_checkbox a.jaune")){
//     const protocol = window.location.protocol + "//"
//     const url = new URL(window.location.href)
//     const host = url.host
//     let pathname = url.pathname
//     if (pathname.includes("wordpress")){
//       pathname = "/wordpress"
//     } else {
//       pathname = ""
//     }
//     const poconf = "/politique-de-confidentialite/"
//     const link = protocol + host + pathname + poconf
    
//     document.querySelector(".gfield_checkbox a.jaune").href = link
//   }
// }, 1000);

if ( objects.is_front_page || objects.is_aventures) {

  const swiper = new Swiper('.myswiper', {
    // Optional parameters
    initialSlide: 0,
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 25,
    watchOverflow: true,
  
    // speed: 400,
      
    // breakpoints: {
    //   576:{
    //     spaceBetween: 50,
    //     slidesPerView: 2,
    //   },
    //   992: {
    //     spaceBetween: 10,
    //     slidesPerView: 'auto',
    //   },
    //   1200: {
    //     spaceBetween: 10,
    //     slidesPerView: 'auto',
    //   }
    // },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
  });
  swiper.update()
  
  // const slide_active = document.querySelector('.slide-active')
  // const slide_active_coords = slide_active.getBoundingClientRect()
  // console.log(slide_active_coords)
  
  // const swiper_bg = document.querySelector('.swiper-bg')
  // // swiper_bg.style.position = "absolute";
  // // swiper_bg.style.width = window.innerWidth + "px";
  // swiper_bg.style.y = slide_active_coords.y + 500 + 'px';

  function update_big_card() {
    
    let big_card = document.querySelector(".slide-active")
    let active_slide = document.querySelector('.swiper-slide-active')

    let slide_photo = active_slide.querySelector(".bg-img")
    let active_photo = big_card.querySelector(".bg-img")
    active_photo.srcset = slide_photo.srcset
    // active_photo.src = slide_photo.src

    let slide_bg_icon = active_slide.querySelector(".background-circle")
    let active_bg_icon = big_card.querySelector(".background-circle")
    active_bg_icon.innerHTML = slide_bg_icon.innerHTML

    let slide_number = active_slide.querySelector(".circle-number")
    let active_number = big_card.querySelector(".circle-number")
    active_number.innerHTML = slide_number.innerHTML

    let slide_title = active_slide.querySelector(".title")
    let active_title = big_card.querySelector(".title")
    active_title.innerHTML = slide_title.innerHTML

    let slide_sub_title = active_slide.querySelector(".sub-title")
    let active_sub_title = big_card.querySelector(".sub-title")
    active_sub_title.innerHTML = slide_sub_title.innerHTML

    let slide_synopsis = active_slide.querySelector(".synopsis")
    let active_synopsis = big_card.querySelector(".synopsis")
    active_synopsis.innerHTML = slide_synopsis.innerHTML

    // let slide_stats = active_slide.querySelector(".full-stats")
    // let active_stats = big_card.querySelector(".stats")
    // active_stats.innerHTML = slide_stats.innerHTML

    let slide_link = active_slide.querySelector(".card-bg")
    let active_link = big_card.querySelector(".more .button")
    let active_link_image = big_card.querySelector(".card-bg")
    active_link.href = slide_link.href
    active_link_image.href = slide_link.href
  }

  update_big_card()

  swiper.on('slideChange', () => {
    setTimeout(() => {
      update_big_card()
    }, 50);
  });

  const sizes = {}
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  window.addEventListener('resize', () =>
  {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
  });

  const elements = document.querySelectorAll('#background-slider .piece')
  const ParallaxElements = Array.from(elements)

  document.addEventListener('scroll', (_event) => {
    let ratioY = scrollY / sizes.height

    ParallaxElements.forEach((_element) => {
      const strength = 3
      let translateY = -ratioY * 10 * strength

      _element.style.transform = `translateY(${translateY}%)`
    })
  });



  // const selecteurs = document.querySelectorAll(".selecteur-wrap")
  // selecteurs.forEach(function(selecteur) {
  //     var button_minus = selecteur.querySelector('.selecteur-bouton.moins')
  //     var button_plus = selecteur.querySelector(".selecteur-bouton.plus")
  //     var players = selecteur.querySelector(".selecteur-bouton.nombre")
  //     var players_max = players.getAttribute('data-max');
  //     var players_min = players.getAttribute('data-min');
  //     var nombre = parseInt(players.innerHTML)

  //     cursor(button_minus, button_plus, nombre, players_min, players_max, selecteur)
  //     calcul(players, nombre)

  //     button_minus.addEventListener('click', () => {
  //         if (nombre > players_min ) {
  //           nombre -= 1
  //         }
  //         cursor(button_minus, button_plus, nombre, players_min, players_max, selecteur)
  //         calcul(players, nombre)
  //     })

  //     button_plus.addEventListener('click', () => {
  //         if (nombre < players_max ) {
  //           nombre -= -1
  //         }
  //         cursor(button_minus, button_plus, nombre, players_min, players_max, selecteur)
  //         calcul(players, nombre)
  //     })
  // });

  // function cursor(button_minus, button_plus, nombre, players_min, players_max, selecteur) {
  //     if (nombre <= players_min ) {
  //         button_minus.style.cursor = "default"
  //     } else if (nombre >= players_max){
  //         button_plus.style.cursor = "default"
  //     } else {
  //         button_minus.style.cursor = "pointer"
  //         button_plus.style.cursor = "pointer"
  //     }

  //     var current_wrapper_all = selecteur.nextElementSibling
  //     var current_wrapper = current_wrapper_all.querySelector(".wrapper[for='price-" + nombre + "']")
  //     var current_wrappers = current_wrapper_all.querySelectorAll(".wrapper")
  //     current_wrappers.forEach(function(wrapper) {
  //       wrapper.style.display = 'none'
  //     })
  //     current_wrapper.style.display = 'flex'
  // }

  // function calcul(players, nombre) {
  //     players.innerHTML = nombre
  // }

  // const swiper_boxes = new Swiper('.swiper-container-boxes', {
  //     // Optional parameters
  //     initialSlide: 0,
  //     centeredSlides: true,
  //     slidesPerView: 'auto',
  //     loop: true
  // });

  // swiper.controller.control = swiper_boxes;
  // swiper_boxes.controller.control = swiper;
  
}

Fancybox.bind('[data-fancybox]', {
  Toolbar: {
    autoEnable: false,
  },
});

